let tile_list = document.querySelectorAll('.tabs__item');

for(let i = 0; i < tile_list.length; i++) {
      let current_shown = tile_list[i].querySelector('.current_shown');
      let items_sum = tile_list[i].querySelector('.items_sum');
      let pagination_info = tile_list[i].querySelector('.pagination-custom');

      let tile_items = tile_list[i].querySelectorAll('.blog-tile');
      let tile_items_hide = tile_list[i].querySelectorAll('.blog-tile__hide');
      let load_button = tile_list[i].querySelector('.load');

      if (pagination_info) {
          let current_items = (items_length) => {
              $(current_shown).text(items_length)
          }
          let sum_items = (items_length) => {
              $(items_sum).text(items_length)
          }

          sum_items(tile_items.length);
          current_items(tile_items.length - tile_items_hide.length);
          pagination_info.classList.add('show');

          load_button.addEventListener('click', (e) => {
              const elementList = [...tile_items];
              for (let i = currentItems; i < 4; i++) {
                  if (elementList[i]) {
                      elementList[i].classList.remove('blog-tile__hide');
                  }
              }
              current_items(tile_items.length - tile_list[i].querySelectorAll('.blog-tile__hide').length);

              if (currentItems >= elementList.length) {
                  event.target.style.display = 'none';
              }
          });   
      }
}

window.addEventListener("load", function() {
const theTabs = document.querySelectorAll(".tabs__nav > a");

function theTabClicks(tabClickEvent) {
    let clickedTab = tabClickEvent.currentTarget;
    let tabParent = tabClickEvent.currentTarget.parentNode.parentNode.parentNode;
    let theTabs = tabParent.querySelectorAll(".tabs__nav > a");
    for (let i = 0; i < theTabs.length; i++) {
        theTabs[i].classList.remove("active");
        theTabs[i].setAttribute("aria-expanded", "false");
        theTabs[i].setAttribute("aria-selected", "false");
    }
    
    clickedTab.classList.add("active");
    clickedTab.setAttribute("aria-expanded", "true");
    clickedTab.setAttribute("aria-selected", "true");

    tabClickEvent.preventDefault();
    let contentPanes = tabParent.querySelectorAll(".tabs__item");
    for (i = 0; i < contentPanes.length; i++) {
        contentPanes[i].classList.remove("active");
    }
    let anchorReference = clickedTab.querySelector("a");
    let activePaneId = clickedTab.getAttribute("href");
    let activePane = tabParent.querySelector(activePaneId);
    activePane.classList.add("active");
}
for (i = 0; i < theTabs.length; i++) {
    theTabs[i].addEventListener("click", theTabClicks)
}
});